import type { DriverRankTierVehicleDistanceRateEntity } from './DriverRankTierVehicleDistanceRateEntity'

export class DriverRankTierEarningSettingEntity {
  id?: string
  tierConfigId?: string
  regionId?: number
  tierName?: string | null
  applyAdditionalFeeToAllRegionTiers?: boolean
  vehicleDistanceRates?: DriverRankTierVehicleDistanceRateEntity[] | null
}
